import { joinPath } from '../../core/utils';
import { MS_PROVIDER_PRICING_FIELD } from './constants';
import type { ModelSubscriptionProviderPaths } from './types';

/** 模型供应商表单路径（与创建页扁平字段一致） */
export function resolveModelSubscriptionProviderPaths(prefix: string): ModelSubscriptionProviderPaths {
  return {
    strategyName: joinPath(prefix, 'strategyName'),
    strategyDisplayName: joinPath(prefix, 'strategyDisplayName'),
    pricing: joinPath(prefix, MS_PROVIDER_PRICING_FIELD),
    useSubResourcePricing: joinPath(prefix, 'useSubResourcePricing'),
    billingTotalTokens: joinPath(prefix, 'billingTotalTokens'),
    inputTokens: joinPath(prefix, 'inputTokens'),
    outputTokens: joinPath(prefix, 'outputTokens'),
  };
}
